import React from 'react';
import {WeaFormItem, WeaInput} from 'ecCom';
import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;

// 元素标题
class ETitle extends React.Component {
    state = {
        value: this.props.value
    };

    render() {
        const {hasLink = true} = this.props;

        return (
            <WeaFormItem label={getLabel(19491, '元素标题')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                <WeaInput id={`element_title_name_input_${this.props.eid}`} inputType='multilang' isBase64={true} value={this.state.value} onChange={value => this.setState({value: value})}/>
                {hasLink && <i className="icon-coms-link portal-esetting-content-title-icon" title={getLabel(16208, '链接地址')} onClick={()=>window.open(`/spa/portal/element/index.html#/main/portal/element?eid=${this.props.eid}`)}/>}
            </WeaFormItem>
        );
    }

    getSaveValues() {
        return this.state.value;
    }
}

export default ETitle;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/setting_new/content/base/ETitle.js